import React from 'react';

import Container from 'react-bootstrap/Container';

import AboutHeader from './AboutHeader';
import AboutContent from './AboutContent';
import AboutServices from './AboutServices';

const AboutLayout = () => {
	return (
		<div style={{ marginTop: 70 }} onLoad={window.scrollTo(0, 0)}>
			<AboutHeader />
			<div className='mx-md-5 mb-4 px-md-5'>
				<Container className='text-center my-3'>
					<h1 style={{ color: '#3367FF' }}>Conócenos</h1>
					<div className='d-flex justify-content-center'>
						<div className='divider' />
					</div>
				</Container>
				<AboutContent />
			</div>
			<AboutServices />
		</div>
	);
};

export default AboutLayout;
